import { eligibleRowStyles } from './SlaGroupInfoModal.styles';

const formatAssigneeNames = assignees =>
  (assignees || [])
    .filter(({ isDeleted }) => !isDeleted)
    .map(({ fullName }) => fullName)
    .join(', ');

const formatDeletedAssigneeNames = assignees =>
  (assignees || [])
    .filter(({ isDeleted }) => isDeleted)
    .map(({ fullName }) => fullName)
    .join(', ');

export const formatTaskSlaGroupLevels = levels =>
  (levels || []).map(level => ({
    ...level,
    potentialAssigneesFullNames: formatAssigneeNames(level.potentialAssignees),
    deletedPotentialAssigneesFullNames: formatDeletedAssigneeNames(level.potentialAssignees),
    assignedUsersFullNames: formatAssigneeNames(level.assignedUsers),
    deletedAssignedUsersFullNames: formatDeletedAssigneeNames(level.assignedUsers),
  }));

export const getActiveRowStyles = ({ isActive }) => (isActive ? eligibleRowStyles : null);
